import { useEffect, useState } from 'react';
import ContentSection from '../../containers/Resources/ContentSection';
import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  SvgIcon,
  Typography
} from '@mui/material';
import { useSelector } from 'react-redux';
import {
  colorPrimary,
  colorTextBlack,
  colorTextGrey
} from '../../config/theme';
import {
  getLibraryList,
  revertResources
} from '../../redux/reducers/resourcesSlice';
import { useDispatch } from 'react-redux';
import { createTitle } from '../../utils/utils';
import {
  getGamificationPoints,
  setActiveModule
} from '../../redux/reducers/layoutSlice';
import { Calendar01Icon, FilterLinesIcon } from '../../utils/iconSvg';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import {
  styledMenuItem,
  StyledSelect
} from '../../containers/productanalytics/UserAndRoleAnalytics';

function Library() {
  const dispatch = useDispatch();
  const [contentData, setContentData] = useState([]);

  const [tempDateFilter, setTempDateFilter] = useState({
    dateType: null,
    startDate: null,
    endDate: null,
    sortBy: null
  });

  const [chart1Payload, setChart1Payload] = useState({
    dateType: 'all',
    startDate: null,
    endDate: null
  });

  const [open, setOpen] = useState(false);
  const [openCalenderModal, setOpenCalendarModal] = useState({
    startDate: false,
    endDate: false
  });

  const { authData } = useSelector(state => state.auth);
  const {
    libraryList,
    isGetLibraryListSuccess,
    isGetContentLoading,
    isUpdateLikeDislikeSuccess,
    isGamificationLoading,
    isGamificationSuccess,
    isDeleteGamificationLoading,
    isDeleteGamificationSuccess,
    isSaveToWatchLaterSuccess
  } = useSelector(state => state.resource);

  useEffect(() => {
    document.title = createTitle('Library');
    dispatch(setActiveModule('Library'));
    dispatch(revertResources());
  }, []);

  useEffect(() => {
    if (!isGamificationLoading && isGamificationSuccess) {
      dispatch(getGamificationPoints(authData?.userId || 0));
    }
    if (!isDeleteGamificationLoading && isDeleteGamificationSuccess) {
      dispatch(getGamificationPoints(authData?.userId || 0));
    }
  }, [
    isGamificationLoading,
    isGamificationSuccess,
    isDeleteGamificationLoading,
    isDeleteGamificationSuccess
  ]);

  useEffect(() => {
    dispatch(getGamificationPoints(authData?.userId || 0));
    const payload = {
      userId: authData?.userId,
      contentType: 'All',
      startDate: chart1Payload.startDate
        ? dayjs(chart1Payload.startDate).format('YYYY-MM-DD')
        : null,
      endDate: chart1Payload.endDate
        ? dayjs(chart1Payload.endDate).format('YYYY-MM-DD')
        : null,
      dateType: chart1Payload.dateType,
      paginationRequest: {
        type: 'all',
        page: 0,
        size: 20
      }
    };
    dispatch(getLibraryList({ payload }));
  }, [
    isUpdateLikeDislikeSuccess,
    chart1Payload,
    tempDateFilter,
    isSaveToWatchLaterSuccess
  ]);

  useEffect(() => {
    if (isGetLibraryListSuccess && libraryList) {
      let result = libraryList?.contentList || [];
      setContentData(result);
    }
  }, [libraryList, isGetLibraryListSuccess]);

  const handleOpenCalendar = type => {
    setOpenCalendarModal({ ...openCalenderModal, [type]: true });
  };

  const handleCloseCalendar = type => {
    setOpenCalendarModal({ ...openCalenderModal, [type]: false });
  };

  return (
    <Box>
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Typography fontSize={'32px'} fontWeight={700}>
          Library
        </Typography>
        <Box sx={{ width: '255px' }}>
          <FormControl variant="outlined" fullWidth size="small">
            <StyledSelect
              IconComponent={Calendar01Icon}
              size="small"
              open={open}
              value={open ? tempDateFilter.dateType : chart1Payload.dateType}
              onOpen={(e, va) => {
                setOpen(true);
                setTempDateFilter({
                  ...tempDateFilter,
                  dateType: chart1Payload.dateType,
                  startDate: chart1Payload.startDate,
                  endDate: chart1Payload.endDate
                });
              }}
              onChange={e => {
                setTempDateFilter({
                  ...tempDateFilter,
                  dateType: e.target.value,
                  startDate: null,
                  endDate: null
                });
              }}
              renderValue={value => {
                let data = open ? tempDateFilter : chart1Payload;
                if (data.dateType == 'all') {
                  return (
                    <Typography
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        color: '#ABB4BD'
                      }}
                    >
                      <SvgIcon fontSize="small" sx={{ marginRight: 1 }}>
                        <FilterLinesIcon color="#ABB4BD" />
                      </SvgIcon>
                      Select date
                    </Typography>
                  );
                }
                switch (data.dateType) {
                  case 'selected_date':
                    return `${data.startDate ? dayjs(data.startDate).format('DD/MM/YY') : ''} - ${data.endDate ? dayjs(data.endDate).format('DD/MM/YY') : ''}`;
                  case 'Week':
                    return 'Last Week';
                  case 'Month':
                    return 'This Month';
                  case 'past_3_months':
                    return 'Past 3 months';
                  case 'Past_1_Year':
                    return 'Past 1 year';
                  default:
                    return;
                }
              }}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#CBD2D9'
                },
                '&:hover  .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#CBD2D9'
                },
                '&.Mui-focused  .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#CBD2D9'
                },
                '& .MuiOutlinedInput-root': {
                  borderRadius: 8
                }
              }}
            >
              <MenuItem
                sx={{ ...styledMenuItem, paddingX: 0, border: 'none' }}
                value="selected_date"
                disableRipple
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Box display={'flex'} gap={1}>
                    <FormControl
                      variant="outlined"
                      size="small"
                      sx={{ width: '175px' }}
                    >
                      <Typography
                        sx={{
                          fontSize: '14px',
                          fontWeight: 600,
                          mb: 0.5
                        }}
                      >
                        Start Date
                      </Typography>
                      <DatePicker
                        maxDate={dayjs()}
                        value={dayjs(tempDateFilter.startDate)}
                        onOpen={() => handleOpenCalendar('startDate')}
                        onClose={() => handleCloseCalendar('startDate')}
                        open={openCalenderModal.startDate}
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            size: 'small',
                            placeholder: 'Start Date',
                            error: false,
                            InputProps: {
                              sx: { color: colorTextBlack },
                              startAdornment: (
                                <InputAdornment position="start">
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      handleOpenCalendar('startDate')
                                    }
                                  >
                                    <SvgIcon
                                      sx={{
                                        width: '16px',
                                        height: '16px',
                                        ml: 1
                                      }}
                                    >
                                      <Calendar01Icon />
                                    </SvgIcon>
                                  </IconButton>
                                </InputAdornment>
                              )
                            },
                            sx: {
                              paddingRight: 0 // Remove extra padding from the hidden icon
                            }
                          }
                        }}
                        onChange={date =>
                          setTempDateFilter({
                            ...tempDateFilter,
                            dateType: 'selected_date',
                            startDate: date,
                            endDate: date
                          })
                        }
                        components={{ OpenPickerIcon: () => null }}
                      />
                    </FormControl>
                    <FormControl
                      variant="outlined"
                      size="small"
                      sx={{ width: '175px' }}
                    >
                      <Typography
                        sx={{
                          fontSize: '14px',
                          fontWeight: 600,
                          mb: 0.5
                        }}
                      >
                        End Date
                      </Typography>
                      <DatePicker
                        minDate={dayjs(tempDateFilter.startDate)}
                        maxDate={dayjs()}
                        // label="End Date"
                        value={dayjs(tempDateFilter.endDate)}
                        open={openCalenderModal.endDate}
                        onOpen={() => handleOpenCalendar('endDate')}
                        onClose={() => handleCloseCalendar('endDate')}
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            size: 'small',
                            error: false,
                            InputProps: {
                              sx: { color: colorTextBlack },
                              startAdornment: (
                                <InputAdornment position="start">
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      handleOpenCalendar('endDate')
                                    }
                                  >
                                    <SvgIcon
                                      sx={{
                                        width: '16px',
                                        height: '16px',
                                        ml: 1
                                      }}
                                    >
                                      <Calendar01Icon />
                                    </SvgIcon>
                                  </IconButton>
                                </InputAdornment>
                              )
                            },
                            sx: {
                              paddingRight: 0 // Remove extra padding from the hidden icon
                            }
                          }
                        }}
                        onChange={date => {
                          setTempDateFilter({
                            ...tempDateFilter,
                            dateType: 'selected_date',
                            endDate: date
                          });
                        }}
                        components={{ OpenPickerIcon: () => null }}
                        // components={{
                        //   OpenPickerIcon: props => (
                        //     <IconButton size="small" {...props}>
                        //       <Calendar01Icon />
                        //     </IconButton>
                        //   )
                        // }}
                      />
                    </FormControl>
                  </Box>
                </LocalizationProvider>
              </MenuItem>

              <MenuItem sx={styledMenuItem} value="Week" disableRipple>
                Last Week
              </MenuItem>
              <MenuItem sx={styledMenuItem} value="Month" disableRipple>
                This Month
              </MenuItem>
              <MenuItem sx={styledMenuItem} value="past_3_months" disableRipple>
                Past 3 month
              </MenuItem>
              <MenuItem sx={styledMenuItem} value="Past_1_Year" disableRipple>
                Past 1 year
              </MenuItem>
              <MenuItem
                // disabled={
                //   !(tempDateFilter.dateType || chart1Payload.dateFilter)
                // }
                sx={{
                  border: '1px solid #E4E7EB',
                  backgroundColor: colorPrimary,
                  marginX: 1,
                  borderRadius: 3,
                  fontWeight: 700,
                  fontSize: '14px',
                  justifyContent: 'center',
                  marginY: 1,
                  '&:hover': {
                    background: colorPrimary
                  }
                }}
                onClick={() => {
                  if (tempDateFilter.dateType) {
                    setChart1Payload({
                      ...chart1Payload,
                      dateType: tempDateFilter.dateType,
                      startDate: tempDateFilter.startDate,
                      endDate: tempDateFilter.endDate
                    });
                  }
                  setTempDateFilter({
                    dateType: null,
                    endDate: null,
                    startDate: null
                  });
                  setOpen(false);
                }}
              >
                Apply
              </MenuItem>
              <MenuItem
                // disabled={
                //   !(tempDateFilter.dateType || chart1Payload.dateFilter)
                // }
                sx={{
                  border: '1px solid #E4E7EB',
                  backgroundColor: colorPrimary,
                  marginX: 1,
                  borderRadius: 3,
                  fontWeight: 700,
                  fontSize: '14px',
                  justifyContent: 'center',
                  marginY: 1,
                  '&:hover': {
                    background: colorPrimary
                  }
                }}
                onClick={() => {
                  setChart1Payload({
                    ...chart1Payload,
                    dateType: 'all',
                    startDate: null,
                    endDate: null
                  });
                  setTempDateFilter({
                    startDate: null,
                    dateType: null,
                    endDate: null
                  });
                  setOpen(false);
                }}
              >
                Close
              </MenuItem>
            </StyledSelect>
          </FormControl>
        </Box>
      </Box>
      <div style={{ marginTop: '1rem' }}>
        {contentData.map((section, index) => {
          return (
            <ContentSection
              key={index}
              title={section?.sectionName}
              videoCount={section?.videoCount || 0}
              documentCount={section?.documentCount || 0}
              audioCount={section?.audioCount || 0}
              flashCardsCount={section?.flashcardCount || 0}
              videos={section?.contents}
              sectionId={section?.sectionId}
              //   tags={}
            />
          );
        })}
        {!isGetContentLoading && contentData?.length === 0 && (
          <Box
            sx={{
              marginBottom: 4,
              backgroundColor: '#FFFFFF',
              padding: '16px',
              borderRadius: '8px',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <Typography
              style={{
                fontFamily: 'Lato',
                fontSize: '14px',
                fontWeight: 700,
                color: colorTextGrey
              }}
            >
              {' '}
              No content available
            </Typography>
          </Box>
        )}
      </div>
    </Box>
  );
}

export default Library;
